import { CheckboxInput, FormItem } from '@framework/form';
import React from 'react';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

export interface INeedSignRuleComponentProps {}

const FIELD_NAME = `rules.${RuleType.NeedSign}.value`;
const FIELD_CUSTOM_MESSAGE = `rules.${RuleType.NeedSign}.customMessage`;

export function NeedSignRuleComponent(props: INeedSignRuleComponentProps) {
  return (
    <FormItem
      name={FIELD_NAME}
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name={FIELD_NAME} defaultChecked={false}>
        Richiede documento firmato
      </CheckboxInput>
      <CustomValidationRuleMessage isGhostType name={FIELD_CUSTOM_MESSAGE} />
    </FormItem>
  );
}
